export const EMAIL_MESSAGE = "유효하지 않은 이메일입니다.";
export const PASSWORD_MESSAGE =
  "비밀번호는 8자 이상 16자 이하, 하나 이상의 영문자와 숫자, @, #, ! 중 하나 이상의 특수문자로 구성되어야 합니다.";
export const CONFIRM_PASSWORD_MESSAGE =
  "입력하신 비밀번호와 일치하지 않습니다.";
